(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Enable scroll wheel scrolling for carousel on desktop (above 1080px)
  (function() {
    const isDesktop = () => window.innerWidth > 1080;
    
    if (!isDesktop()) return;
    
    const carousel = document.querySelector('.product-information__media slideshow-component');
    if (!carousel) return;
    
    const scroller = carousel?.querySelector('slideshow-slides');
    if (!scroller) return;
    
    let isMouseOverCarousel = false;
    
    // Track when mouse enters/exits carousel
    carousel.addEventListener('mouseenter', () => {
      isMouseOverCarousel = true;
    });
    
    carousel.addEventListener('mouseleave', () => {
      isMouseOverCarousel = false;
    });
    
    // Handle wheel events
    carousel.addEventListener('wheel', (e) => {
      if (!isMouseOverCarousel || !isDesktop()) return;
      
      // Only handle vertical wheel scrolling
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        
        // Convert vertical scroll to horizontal
        scroller.scrollBy({
          left: e.deltaY,
          behavior: 'auto'
        });
      }
    }, { passive: false });
    
    // Handle window resize to re-check desktop status
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!isDesktop()) {
          isMouseOverCarousel = false;
        }
      }, 100);
    });
  })();

  // Move first 3 blocks (title, price, description) to left column on desktop
  (function() {
    const isDesktop = () => window.innerWidth > 1080;
    
    function moveBlocksToLeftColumn() {
      const leftContent = document.querySelector('.product-information__left-content');
      const groupBlockContent = document.querySelector('.product-details > .group-block > .group-block-content');
      const groupBlock = document.querySelector('.product-details > .group-block');
      
      if (!leftContent || !groupBlockContent || !groupBlock) return;
      
      if (!isDesktop()) {
        // On mobile, move blocks back to their original position
        if (leftContent.children.length > 0) {
          const groupBlockContent = document.querySelector('.product-details > .group-block > .group-block-content');
          if (groupBlockContent) {
            const movedBlocks = Array.from(leftContent.children);
            movedBlocks.reverse(); // Reverse to maintain original order when inserting
            movedBlocks.forEach((block) => {
              const firstChild = groupBlockContent.firstElementChild;
              if (firstChild && !firstChild.classList.contains('view-product-title')) {
                groupBlockContent.insertBefore(block, firstChild);
              } else {
                const viewTitle = groupBlockContent.querySelector('.view-product-title');
                if (viewTitle) {
                  groupBlockContent.insertBefore(block, viewTitle.nextSibling);
                } else {
                  groupBlockContent.insertBefore(block, groupBlockContent.firstChild);
                }
              }
            });
          }
        }
        return;
      }

      // Get all direct children blocks from group-block-content (excluding view-product-title)
      // The blocks are inside .group-block-content, not directly in .group-block
      const allBlocks = Array.from(groupBlockContent.children).filter(block => {
        // Exclude view-product-title
        if (block.classList.contains('view-product-title')) return false;
        // Make sure it's a direct child of group-block-content
        return block.parentElement === groupBlockContent;
      });
      
      // Find the first 3 blocks: title (first text-block with heading), price (first product-price), description
      // Title: first text-block that contains a heading
      const titleBlock = allBlocks.find(block => {
        if (!block.classList.contains('text-block')) return false;
        if (block.classList.contains('rte')) return false;
        return block.querySelector('h1, h2, h3, h4, h5, h6') !== null;
      }) || allBlocks.find(block => {
        // Fallback: first text-block that's not rte
        return block.classList.contains('text-block') && !block.classList.contains('rte');
      });
      
      // Price: first product-price element
      const priceBlock = allBlocks.find(block => {
        return block.tagName === 'PRODUCT-PRICE' || block.querySelector('product-price') !== null;
      });
      
      // Description: product-description element or first substantial rte block
      let descriptionBlock = allBlocks.find(block => {
        return block.tagName === 'PRODUCT-DESCRIPTION' || block.querySelector('product-description') !== null;
      });
      
      if (!descriptionBlock) {
        // Look for rte blocks - could be .text-block.rte or rte-formatter
        const rteBlocks = allBlocks.filter(block => {
          return block.classList.contains('rte') || 
                 block.querySelector('rte-formatter') !== null ||
                 (block.classList.contains('text-block') && block.querySelector('.rte') !== null);
        });
        
        // Find the one with substantial content (product description)
        descriptionBlock = rteBlocks.find(block => {
          const textContent = block.textContent.trim();
          // Must be substantial and contain product description keywords
          return textContent.length > 200 && 
                 /crafted|fabric|garment|fit|logo|embroidered|ribbed|cuffs|waistband|drawstrings|grommets|zipper|Classic Heavyweight|400 GSM|cotton fleece/i.test(textContent);
        }) || rteBlocks.find(block => {
          const textContent = block.textContent.trim();
          return textContent.length > 200 && 
                 !/shipping|returns|satisfied|customer|purchase|goal|totally/i.test(textContent);
        });
      }
      
      // Move blocks to left column (only if not already there and they are direct children)
      [titleBlock, priceBlock, descriptionBlock].forEach(block => {
        if (block && 
            !leftContent.contains(block) && 
            block.parentElement === groupBlockContent &&
            block !== null) {
          // Make sure we're not moving a container that has variant-picker, buy-buttons, or accordion inside
          const hasVariantPicker = block.querySelector('variant-picker') !== null;
          const hasBuyButtons = block.querySelector('buy-buttons') !== null;
          const hasAccordion = block.querySelector('accordion, details[class*="accordion"]') !== null || 
                               block.tagName === 'ACCORDION' ||
                               block.classList.contains('accordion');
          
          // Don't move if it contains elements we want to keep in the right column
          if (!hasVariantPicker && !hasBuyButtons && !hasAccordion) {
            leftContent.appendChild(block);
          }
        }
      });
      
      // Make sure accordion stays in right column - move it back if it was moved
      const accordionBlock = allBlocks.find(block => {
        return block.tagName === 'ACCORDION' ||
               block.classList.contains('accordion') ||
               block.querySelector('accordion, details[class*="accordion"]') !== null;
      });
      
      if (accordionBlock && leftContent.contains(accordionBlock)) {
        // Move accordion back to its original position in group-block-content
        const movedBlocks = Array.from(leftContent.children);
        const accordionIndex = allBlocks.indexOf(accordionBlock);
        const insertAfter = allBlocks[accordionIndex - 1];
        
        if (insertAfter && groupBlockContent.contains(insertAfter)) {
          groupBlockContent.insertBefore(accordionBlock, insertAfter.nextSibling);
        } else {
          // Insert at the end if we can't find the right position
          groupBlockContent.appendChild(accordionBlock);
        }
      }
    }
    
    // Run on load and resize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveBlocksToLeftColumn);
    } else {
      moveBlocksToLeftColumn();
    }
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(moveBlocksToLeftColumn, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
